import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDSPdWj_QSQmhfdBGN6_nmE7sjVf0J9NMg",
  authDomain: "invoice-engine-52a3a.firebaseapp.com",
  projectId: "invoice-engine-52a3a",
  storageBucket: "invoice-engine-52a3a.appspot.com",
  messagingSenderId: "321706850232",
  appId: "1:321706850232:web:9110bd67a24060e25e814d"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
